export const ESTADO_PROPIEDAD = {
  rentada_al_corriente: { label: "Rentada · Al corriente", className: "bg-emerald-100 text-emerald-700" },
  rentada_con_adeudo: { label: "Rentada · Con adeudo", className: "bg-red-100 text-red-700" },
  disponible: { label: "Disponible", className: "bg-blue-100 text-blue-700" },
  proxima_a_desocuparse: { label: "Próxima a desocuparse", className: "bg-amber-100 text-amber-700" },
  en_renovacion: { label: "En renovación", className: "bg-indigo-100 text-indigo-700" },
  en_mantenimiento: { label: "En mantenimiento", className: "bg-orange-100 text-orange-700" },
  uso_propietario: { label: "Uso del propietario", className: "bg-gray-200 text-gray-700" },
  inactiva: { label: "Inactiva", className: "bg-gray-100 text-gray-500" },
};

export const formatCurrency = (amount) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(amount ?? 0);

export const formatDate = (dateString) => {
  if (!dateString) return "—";
  const [year, month, day] = dateString.split("T")[0].split("-");
  const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  return date.toLocaleDateString("es-MX", { day: "numeric", month: "short", year: "numeric" });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "—";
  const date = new Date(dateString);
  if (isNaN(date)) return dateString;
  return date.toLocaleDateString("es-MX", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};
